<template>
  <div v-show="widgetOptions.showOpenButton == 1 && widgetOptions.customTrigger != 1 && hide == false"
    :class="['adabundle-trigger-button-box',widgetOptions.buttonPosition, 'adb-entrance-'+widgetOptions.buttonEntranceAnimation, 'adb-hover-'+widgetOptions.buttonHoverAnimation]">
    <button id="adabundle-trigger-button" class="adb-icon-position-before" aria-label="Open Accessibility Panel"
      data-adabundle-trigger="">

      <span v-if="buttonIcon" v-html="processButtonIcon(widgetOptions.buttonIcon)"
        class="adabundle-trigger-button-icon">
      </span>

      <span v-else class="adabundle-trigger-button-icon">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 63 63">
          <circle class="a" cx="31.49" cy="16.08" r="5.5" transform="translate(-2.14 26.98) rotate(-45)" />
          <path class="a"
            d="M47.62,22.28a88.73,88.73,0,0,1-32.25,0,1.63,1.63,0,0,0-1.92,1.32,1.64,1.64,0,0,0,1.32,1.92,92,92,0,0,0,10.92,1.34,2.62,2.62,0,0,1,2.42,2.93l-.32,2.75a54.14,54.14,0,0,1-3,12.67l-2,5.35a1.65,1.65,0,0,0,3.09,1.16v0l.49-1c1.6-3.41,3.09-6.9,4.45-10.43a.74.74,0,0,1,1.38,0c1.36,3.53,2.85,7,4.45,10.44l.51,1.09h0a1.64,1.64,0,0,0,1.48,1,1.6,1.6,0,0,0,.57-.11,1.64,1.64,0,0,0,1-2.12l-2-5.35a54.67,54.67,0,0,1-3-12.67l-.31-2.77a2.61,2.61,0,0,1,2.42-2.91,92.51,92.51,0,0,0,10.83-1.32,1.73,1.73,0,0,0,1.44-1.67A1.65,1.65,0,0,0,47.62,22.28Z" />
          <path class="b"
            d="M31.5,0A31.5,31.5,0,1,0,63,31.5,31.53,31.53,0,0,0,31.5,0Zm0,60A28.5,28.5,0,1,1,60,31.5,28.54,28.54,0,0,1,31.5,60Z" />
        </svg>
      </span>
    </button>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import Utility from '../common/Utility';
import HTTP from "../common/Http";

export default {
  name: "TriggerButton",
  components: {
  },
  mounted() {

  },
  data() {
    return {
      isLoading: false,
      svgIcon: '',
      hide: false,
      defaultIcon: '/images/widget-icon.svg'
    }
  },
  computed: {
    ...mapState([
      "timeStamp",
      "wid",
      "widgetOptions",
    ]),
    shouldShowOpenButton() {
      return this.widgetOptionsthis.widgetOptions.showOpenButton == 1
    },
    showDefaultIcon() {
      return widgetOptions.buttonIcon === defaultIcon || !this.widgetOptions.buttonIcon;
    },
    buttonIcon() {
      const isSpecialIcon = [
        'font-awesome/audio-description.svg',
        '/images/widget-icon.svg'
      ].includes(this.widgetOptions.buttonIcon);

      return this.widgetOptions.buttonIcon && !isSpecialIcon;
    }
  },
  created() {
    this.unsubscribe = this.$store.subscribe((mutation, state) => {
      if (mutation.type === 'setWidgetOptions') {
        this.widgetOptions = state.widgetOptions;
        this.init()
        if (Utility.getCookie('adabundle-hide') == '1') {
          this.hide = true;
        }
        console.log('HIDE ADABUNDLE TRIGGER', this.hide)
      }
    });
  },
  beforeDestroy() {
    this.unsubscribe();
  },
  methods: {
    processButtonIcon(svg) {
      if (svg.startsWith('%3Csvg%')) {
        this.svgIcon = decodeURIComponent(svg);
      } else {
        this.svgIcon = svg;
      }
      return this.svgIcon;
    },
    init() {

      let buttonStyle = document.createElement('style');

      buttonStyle.innerHTML = `
              /*noinspection CssUnusedSymbol*/
              .adabundle-trigger-button-box {
                    --adabundle-btn-margin: ${this.widgetOptions.buttonMargin}px;
                    --adabundle-btn-padding: ${this.widgetOptions.buttonPadding}px;
                    --adabundle-btn-radius: ${this.widgetOptions.buttonBorderRadius}px;
                    --adabundle-btn-color: ${this.widgetOptions.buttonColor};
                    --adabundle-btn-color-hover: ${this.widgetOptions.buttonColor};
                    --adabundle-btn-bg: ${this.widgetOptions.buttonBgcolor};
                    --adabundle-btn-bg-hover: ${this.widgetOptions.buttonBgcolor};
                    --adabundle-btn-size: ${this.widgetOptions.buttonSize}px;
                    --adabundle-btn-delay: ${this.widgetOptions.buttonEntranceTimeout}s;
              }

              .adabundle-tts {

                  --adabundle-tts-bg: ${this.widgetOptions.buttonBgcolor};
                  --adabundle-tts-color: ${this.widgetOptions.buttonColor};

              }

              #adabundle-accessibility-profiles-box .adabundle-accessibility-profile-item input:checked + .switch {
                  background:  ${this.widgetOptions.buttonBgcolor};
              }

              .adabundle-input-spinner-box .adabundle-control .adabundle-plus:before, .adabundle-input-spinner-box .adabundle-control .adabundle-minus:before{
                background-color:  ${this.widgetOptions.buttonBgcolor};
              }
          `;

      document.head.appendChild(buttonStyle);
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.adabundle-trigger-button-icon svg path {
  fill: var(--adabundle-btn-color);
}
</style>
